import {IAdapter} from '@drl/core/api/adapters/i-adapter';
import {ApiService} from '@drl/core/api/api.service';
import {GetListAPICommand} from '@drl/core/core.module';
import {environment} from '@drl/env/environment';

export class GetPatientAppointmentsCommand<T> extends GetListAPICommand<T> {
  constructor(apiService: ApiService, adapter: IAdapter<T>, patientId: number) {
    super(
      apiService,
      adapter,
      `${environment.patientApiUrl}/patients/${patientId}/appointments`,
    );
  }
}
